module.exports = __webpack_public_path__ + "static/media/david-james-retail-solutions.65007eb2.png";